module.exports = __webpack_public_path__ + "static/media/info-circlePending.18c93e3c.svg";